module.exports = __webpack_public_path__ + "static/media/TN-Men-Sneakers.1993a6bf.svg";